
<div class="example-box col-mod-12" cdkDrag (cdkDragDropped)="onDrop($event)">
  <div class="resize-handle" cdkDragResize [resizeEdges]="{ bottom: true, right: true }" 
    (cdkDragResizeEnded)="onResize($event)">
    <ng-content></ng-content>
  </div>
  
</div>